import React, { useState } from 'react';
import { Button, Menu, Text } from '@mantine/core';
import {
  IconChevronDown,
  IconListDetails,
  type TablerIcon,
} from '@tabler/icons-react';
import { ganttToolbarButtonProps } from './ganttToolbarStyles';
import type { GanttToolsActionItem } from './tools/GanttToolsActionList';

export interface GanttTasksMenuProps {
  items: GanttToolsActionItem[];
}

/** Toolbar popover: Assign users, reassign locations, fix types, invalidate. */
export function GanttTasksMenu({ items }: GanttTasksMenuProps) {
  const [opened, setOpened] = useState(false);

  return (
    <Menu
      opened={opened}
      onChange={setOpened}
      shadow="md"
      radius="md"
      width={280}
      position="bottom-start"
      withinPortal
    >
      <Menu.Target>
        <Button
          {...ganttToolbarButtonProps}
          variant="default"
          type="button"
          leftSection={<IconListDetails size={14} stroke={1.75} />}
          rightSection={<IconChevronDown size={14} stroke={1.75} />}
          onClick={() => setOpened((o) => !o)}
          aria-label="Tasks"
          aria-expanded={opened}
        >
          Tasks
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {items.map((item) => {
          const Icon = item.Icon as TablerIcon | undefined;
          return (
            <React.Fragment key={item.id}>
              {item.id === 'gantt-invalidate-fetch' ? <Menu.Divider /> : null}
              <Menu.Item
                disabled={item.disabled}
                leftSection={Icon ? <Icon size={14} stroke={1.6} /> : undefined}
                onClick={() => {
                  if (item.disabled) return;
                  item.onActivate();
                  setOpened(false);
                }}
              >
                <Text size="sm" fw={600}>
                  {item.label}
                </Text>
                {item.description ? (
                  <Text size="xs" c="dimmed" lineClamp={2}>
                    {item.description}
                  </Text>
                ) : null}
              </Menu.Item>
            </React.Fragment>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
}
